export const adminNotificationsRoutes = {
  list: "",
  selfSettings: "settings",
  otherUserSettings: "settings/:userId",
} as const;
